export default __webpack_public_path__ + "static/media/section8-img5.fb5524de.png";